/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-name[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}div.content-name[_ngcontent-%COMP%]   app-sos-inverso[_ngcontent-%COMP%]{margin-left:20px}.user-id[_ngcontent-%COMP%]{font-size:2rem;margin-bottom:30px}"];
export { styles as styles };
